import React, { useState, useEffect } from "react";
import ConnectAPI from "../../services/api";
import { Button ,Modal,Table, IconPlus, Tabs  } from "@veneer/core";
import { useTranslation } from "react-i18next";
import Email_view from "./Email_Views";
import $, { map } from 'jquery';
import EmailShow from "./EmailShow";

const EmailsSend = (props) => {
    const connectApi = new ConnectAPI();
    const { t, i18n } = useTranslation();
    const [activeTabIndex, setactiveTabIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showdetails, setshowdetails]=useState(false);
    const [DataTemplate, setDatatemplate]=useState([]);
    const [DataSent, setDatasent]=useState([]);
    const [templatedetail, settemplatedetail]=useState();
    const [isnew, setisnew]=useState();
    useEffect(()=>{
        //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate
    
        connectApi
        .get(
          "api/Channels/getemails",
          "",
          consolid
        )
    },[]);
    const consolid = (status, data) => {
        var template=[];
        var emails=[];
        console.log(data);
        if (status=="200"){
            data.templates.forEach(element => {
                template.push(element);
            });
            data.send.forEach(element => {
                emails.push(element);
            });
        }
        setDatasent(emails);
        setDatatemplate(template);
        
    }
    const hideSCDetailsModal = () => {
        setShowModal(false);
    }
    const close_details=()=>{
        setshowdetails(false);
    }
    const new_email=()=>{
        setShowModal(true);
        setisnew("YES")
        settemplatedetail();
    }
    const selectTab = (event) => (index) => {
        setactiveTabIndex(index);
    };
    function active_details(e) {
        var id = $(e.target).closest('tr').children().eq(0).text();
        if (id!="Id"){
          let al = DataSent.find(al => al.idtemplate == id);
          settemplatedetail(al);
          setshowdetails(true);
        }
    }
    const TableSent=()=>{
        return(
            <>
                <Table onClick={active_details}
                    columns={[
                        {
                        id: 'idtemplate',
                        label: 'Id',
                        },
                        {
                            id:"date",
                            label:t("date"),
                        },
                        {
                        id: 'description',
                        label: t("subject"),
                        },
                        {
                            id:'audiencelevel',
                            label:t("Audiencelevel")
                        },
                        {
                            id:'email',
                            label:t("sendby")
                        }
                    ]}
                    data={DataSent}
                />
            </>
        );
    }
    function activateLasers(e) {
        var id = $(e.target).closest('tr').children().eq(0).text();
        if (id!="Id"){
          let al = DataTemplate.find(al => al.idtemplate == id);
          settemplatedetail(al);
          setisnew("NO")
          setShowModal(true);
        }
    }
    
    const TableTemplate=()=>{
        return(
            <>
                <Table onClick={activateLasers}
                    columns={[
                        {
                            id: 'idtemplate',
                            label: 'Id',
                        },
                        {
                            id: 'description',
                            label: t("subject"),
                        }
                    ]}
                    data={DataTemplate}
                />
            </>
        );
    }
    return(
        <>
         <div className="vn-button-group--horizontal">
            <br/>
            <Button leadingIcon={<IconPlus />} onClick={new_email}>
                {t("new_email")}
            </Button>
        </div>
        <br/>
        <Tabs
            controlId="default"
            onChangeTab={selectTab()}
            selectedTabId={activeTabIndex}
            tabs={[
                { id: 0, label: t("templates"), content: <div style={{ padding: '30px' }}><TableTemplate/></div> },
                { id: 1, label: t("sent"), content: <div style={{ padding: '30px' }}><TableSent/></div> },
            ]}
        />
        <Email_view  onShowModal={showModal} setOnShowModal={setShowModal} onCloseSCDetailsModal={hideSCDetailsModal} details={templatedetail} isnew={isnew}/>
        {(typeof templatedetail !== 'undefined')?(
               <EmailShow onShowModal={showdetails} setOnShowModal={setshowdetails} onCloseSCDetailsModal={close_details} details={templatedetail.log}/>
                
            ):("")}

        
      
        </>
    );
}
export default EmailsSend;